import { render, staticRenderFns } from "./LoginCallBack.vue?vue&type=template&id=56f05715"
import script from "./LoginCallBack.vue?vue&type=script&lang=js"
export * from "./LoginCallBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports